module.exports = __webpack_public_path__ + "img/news5.eba89ea7.jpg";